export default __webpack_public_path__ + "static/iurisprudentia_Merriweather-72fc486dfd65ab600ad37ac7a6963d44.png";